module.exports = __webpack_public_path__ + "static/media/Asset 35.d16708be.png";